import Vue from "vue";
import VueRouter from "vue-router";
import Nutech from "../views/Nutech.vue";
import ClientOne from "../views/ClientOne";
import ClientTwo from "../views/ClientTwo";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "nutech",
    component: Nutech
  },
  {
    path: "/client/one",
    name: "clientone",
    component: ClientOne
  },
  {
    path: "/client/two",
    name: "clienttwo",
    component: ClientTwo
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
